export default {
    buttons: {
        activate_promocode: ({freecash}) => freecash.buttons.activate_promocode
    }
}